import React from "react";

const CashbackComponent = ({ cashback, currencySymbol, userId }) => {
  const isNumeric = !isNaN(parseFloat(cashback)) && isFinite(cashback);

  // Determine if cashback is missed or earned based on userId
  const isMissed = !userId;


  return (
    <div
      className={`flex mt-2 items-center border  rounded-lg overflow-hidden ${isMissed ? "border-[#FF3D3C]" : "border-[#b7ff1c]"
        }`}
    >
      <p
        className={`px-2 py-2 flex items-center justify-center font-bold w-1/3 ${isMissed ? "bg-[#FF3D3C] text-white" : "bg-[#b7ff1c] text-black"
          }`}
      >
        {isMissed ? "Cashback Missed" : "Cashback Earned"}
      </p>
      <p
        className={`flex-1 text-right px-4 mr-10 py-2 ${isMissed ? "text-[#FF3D3C]" : "text-primary font-semibold"}`}
      >

        {isNumeric
          ? `${isMissed ? "-" : "+"} ${currencySymbol}${parseFloat(
            cashback
          ).toFixed(2)}`
          : cashback}
      </p>
    </div>
  );
};

export default CashbackComponent;
